export default "__VITE_ASSET__j36Vg96v__"